module.exports = __webpack_public_path__ + "static/media/B__V8_0000V2.eaa8fa55.png";